import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon } from "@ui5/webcomponents-react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import "@ui5/webcomponents-icons/dist/AllIcons.js";
import httpRequest from "../httpRequest";

const TopSuppliersCard = ({ invoiceData }) => {
  const [topSuppliers, setTopSuppliers] = useState([]);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    fetchVendors();
  }, []);

  useEffect(() => {
    calculateTopSuppliers();
  }, [invoiceData, vendors]);

  const fetchVendors = async () => {
    try {
      const resp = await httpRequest.get(`${process.env.REACT_APP_BACKEND_URL}/get-vendors`);
      setVendors(resp.data.vendors);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const calculateTopSuppliers = () => {
    if (!invoiceData || invoiceData.length === 0) {
      setTopSuppliers([]);
      return;
    }

    const suppliersMap = {};

    invoiceData.forEach((invoice) => {
      const vendorCode = invoice.vendor_code;
      if (suppliersMap[vendorCode]) {
        suppliersMap[vendorCode].frequency += 1;
      } else {
        const vendor = vendors.find((v) => v.vendor_code === vendorCode);
        suppliersMap[vendorCode] = {
          vendor_code: vendorCode,
          vendor_name: vendor ? vendor.vendor_name : "Unknown",
          vendor_short_name: vendor ? vendor.vendor_name.split(" ")[0] : "Unknown",
          frequency: 1,
        };
      }
    });

    const suppliersArray = Object.keys(suppliersMap).map((key) => suppliersMap[key]);
    suppliersArray.sort((a, b) => b.frequency - a.frequency);
    setTopSuppliers(suppliersArray.slice(0, 5)); // Limit to top 5 suppliers
  };

  const sapColors = ["#0a6ed1", "#004b87", "#f0ab00", "#7ca10c", "#d72d42"];

  const getTicks = (maxValue) => {
    const ticks = [];
    for (let i = 0; i <= maxValue; i++) {
      ticks.push(i);
    }
    return ticks;
  };

  const maxFrequency = Math.max(...topSuppliers.map(supplier => supplier.frequency), 0);

  return (
    <Card
      header={<CardHeader avatar={<Icon name="supplier" />} subtitleText="By Frequency" titleText="Top Suppliers" />}
      style={{ width: '100%', height: '475px',  margin: 'auto' }}
    >
      <div style={{ padding: '0 20px' }}>
        <ResponsiveContainer width="100%" height={370}>
          <BarChart layout="vertical" data={topSuppliers}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              type="number" 
              domain={[0, 'dataMax']}
              ticks={getTicks(maxFrequency)}
            />
            <YAxis dataKey="vendor_short_name" type="category" />
            <Tooltip formatter={(value, name, props) => [`${value}`, `${props.payload.vendor_name}`]} />
            <Bar dataKey="frequency">
              {topSuppliers.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={sapColors[index % sapColors.length]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default TopSuppliersCard;
